import { Link } from 'react-router-dom'

/**
 * Spec 160 (FR-015, retrait E2 accepté le 2026-10-11, research D-160-11) — la cloche de la barre du haut.
 *
 * Elle portait un point rouge PERMANENT, sans action ni nom : un faux signal, et le bouton sans nom compté sur chacun des
 * 142 écrans du relevé. Elle dit désormais le nombre d'alertes actives du client affiché — le même que la page Alertes —,
 * ne montre rien quand il est nul, et mène à cette page.
 */
export function Cloche({ nombre, href }: { nombre: number; href: string }) {
  const nom = nombre > 0 ? `Alertes : ${nombre} active${nombre > 1 ? 's' : ''}` : 'Alertes : aucune active'
  return (
    <Link
      to={href}
      aria-label={nom}
      title={nom}
      className="relative flex-shrink-0 inline-flex items-center justify-center text-foreground rounded-sm hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
      style={{ minWidth: 28, minHeight: 28 }}
    >
      <svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
        <path d="M8 1.5A4.5 4.5 0 003.5 6v3.5L2 11.5h12l-1.5-2V6A4.5 4.5 0 008 1.5z"/>
        <path d="M6.5 11.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5"/>
      </svg>
      {nombre > 0 && (
        <span
          data-pastille=""
          aria-hidden="true"
          style={{
            position: 'absolute', top: -2, right: -4, minWidth: 16, height: 16, padding: '0 4px',
            borderRadius: 9999, background: 'hsl(var(--destructive))', color: 'hsl(var(--destructive-foreground))',
            fontFamily: 'var(--font-body)', fontSize: 'var(--fs-caption)', fontWeight: 'bold', lineHeight: '16px',
            textAlign: 'center',
          }}
        >
          {nombre > 99 ? '99+' : nombre}
        </span>
      )}
    </Link>
  )
}
